import Icon from "~icons/fa6-solid/caret-down";
import classnames from "classnames";

export default function CaretDownIcon({ expanded }: { expanded: boolean }) {
  return (
    <Icon
      className={classnames("size-5 text-gray-400 transition-transform", {
        "rotate-180": expanded,
      })}
    />
  );
}
